// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__YxHQZ","title":"ClientReferral_title__1yAus","itemText":"ClientReferral_itemText__T96r4"};